module.exports = __webpack_public_path__ + "plus-2021jump/images/live_commerce_ttl.edce6d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/live_commerce_ttl.png
// module id = pO8z
// module chunks = 0